import { z } from 'zod';
import { DataGridViewType } from '@/features/DataGrid';
import { filtersValidator } from '@/features/filters';
import {
  columnsWidthStateValidator,
  DateScale,
  Lifetime,
  serializedDateRangeValueObjectValidator,
  sortingValidator,
} from '@/shared/types';
import type { ColumnsConfig } from '@/shared/types';

export interface Meta {
  defaultColumns: {
    dimensions: string[];
    metric: string;
  };
  config: ColumnsConfig;
  dimensions: string[];
  metrics: string[];
}

type DataRow = Record<string, string | number>;

export interface DataResponse {
  rows: DataRow[];
  columns: string[];
  hasNextPage: boolean;
}

export interface TreeDataResponse {
  rows: DataRow[];
  columns: string[];
}

export enum ValueType {
  absolute = 'absolute',
  percent = 'percent',
}

const highlightValidator = z.object({
  levels: z.number(),
  valueType: z.enum(ValueType),
});

export type Highlight = z.infer<typeof highlightValidator>;

export const dataConfigValidator = z.object({
  dateScale: z.enum(DateScale),
  dateRange: serializedDateRangeValueObjectValidator,
  lifetime: z.enum(Lifetime),
  probabilisticAttribution: z.boolean(),
  filters: filtersValidator,
  dimensions: z.array(z.string()),
  metric: z.string(),
  highlight: highlightValidator,
  dataGridViewType: z.enum(DataGridViewType),
  columnsWidth: columnsWidthStateValidator,
  sorting: sortingValidator,
  rowHeight: z.number(),
});

export type DataConfig = z.infer<typeof dataConfigValidator>;
